export const calculateUnreadCount = (lastSeenAt: string | null, messages: Array<App.ChatMessage>): number => {
  if (!messages || messages.length === 0) return 0

  if (!lastSeenAt) {
    return messages.filter(msg => msg.sender === 'agent').length
  }

  const lastSeenTimestamp = new Date(lastSeenAt).getTime()

  return messages.filter(msg => {
    if (msg.sender !== 'agent') return false

    if (!msg.createdAt) return false

    const messageTimestamp = new Date(msg.createdAt).getTime()

    return messageTimestamp > lastSeenTimestamp
  }).length
}

export const hasNewMessages = (lastSeenAt: string | null, updatedAt: string): boolean => {
  if (!updatedAt) return false
  if (!lastSeenAt) return true

  const lastSeenTimestamp = new Date(lastSeenAt).getTime()
  const updatedAtTimestamp = new Date(updatedAt).getTime()

  return updatedAtTimestamp > lastSeenTimestamp
}
